import type { ISectionState } from '@/store/modules/section/types';

export const state: ISectionState = {
  periods: null,
};
